import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowRight } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "@/lib/newsletter";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const submitNewsletter = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Please enter your email");
    try {
      await subscribeNewsletter(email, "footer");
      toast.success("You're subscribed to the newsletter.");
      setEmail("");
    } catch (error) {
      console.error(error);
      toast.error("Could not subscribe. Please try again.");
    }
  };

  return (
    <footer className="bg-ivory border-t border-line mt-24">
      <div className="container-nc py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-2xl text-espresso mb-3">Note Console</div>
          <p className="text-sm text-muted_brown max-w-xs leading-relaxed">
            For the driven. By design. Built to help you plan better, live better, and
            achieve more.
          </p>
          <div className="flex gap-4 mt-6 text-espresso">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="hover:text-gold transition-colors"
            >
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a
              href="mailto:your.noteconsole@gmail.com"
              data-testid="footer-email"
              className="hover:text-gold transition-colors"
            >
              <Mail size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="overline mb-4">Shop</h4>
          <ul className="space-y-3 text-sm text-muted_brown">
            <li><Link to="/shop" className="hover:text-espresso">All Planners</Link></li>
            <li><Link to="/shop?cat=accessories" className="hover:text-espresso">Accessories</Link></li>
            <li><Link to="/shop?cat=bundles" className="hover:text-espresso">Bundles</Link></li>
            <li><Link to="/bulk" className="hover:text-espresso">Bulk &amp; Corporate</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">Planner</h4>
          <ul className="space-y-3 text-sm text-muted_brown">
            <li><Link to="/product/life-os-planner" className="hover:text-espresso">The Life OS Planner</Link></li>
            <li><Link to="/inside-the-planner" className="hover:text-espresso">What's Inside</Link></li>
            <li><Link to="/inside-the-planner#how" className="hover:text-espresso">How It Works</Link></li>
            <li><Link to="/help" className="hover:text-espresso">FAQs</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-4">Newsletter</h4>
          <p className="text-sm text-muted_brown mb-4">
            Get planning tips and exclusive offers straight to your inbox.
          </p>
          <form
            className="flex items-center border border-line rounded-full bg-cream overflow-hidden"
            onSubmit={submitNewsletter}
          >
            <input
              data-testid="newsletter-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 bg-transparent px-4 py-2.5 text-sm outline-none"
            />
            <button
              data-testid="newsletter-submit"
              className="bg-espresso text-cream w-10 h-10 flex items-center justify-center hover:bg-espresso-dark transition-colors"
              aria-label="Subscribe"
            >
              <ArrowRight size={16} />
            </button>
          </form>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="container-nc py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-muted_brown">
          <div>© {new Date().getFullYear()} Note Console. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="hover:text-espresso">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-espresso">Terms of Service</Link>
            <Link to="/shipping-returns" className="hover:text-espresso">Shipping & Issue Support</Link>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-espresso">Sign in</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
